import { render, staticRenderFns } from "./ConsultantsTableRowSkeleton.vue?vue&type=template&id=0ddddbb3&scoped=true&lang=pug&functional=true&"
import script from "./ConsultantsTableRowSkeleton.vue?vue&type=script&lang=js&"
export * from "./ConsultantsTableRowSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantsTableRowSkeleton.vue?vue&type=style&index=0&id=0ddddbb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0ddddbb3",
  null
  
)

export default component.exports